// extracted by mini-css-extract-plugin
module.exports = {"options":"options_options__irZPp","selector":"options_selector__v9xpW","OptionsPage":"options_OptionsPage__5v4R8","tables":"options_tables__AT__3","form":"options_form__GhlkD"};